import api from "@/lib/api";

export async function getLogs(solicitacaoID) {
  const { data } = await api.get("/secretaria-digital/logs", { params: { solicitacaoID } })
  return data
}